import Vue from "vue";
import VueMarkdownIt from "vue-markdown-it";

import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop } from "@/decorators";

@Component({
    components: {
        shortcutComponent,
        VueMarkdownIt,
    },
})
export default class CriteriosComponent extends Vue {
    @Prop({ type: String, default: "" }) textoCriterios: String;
    @Prop({ type: String, default: "" }) tituloModal: String;

    private shortCutComponent: ShortcutComponent = null;

    public async open() {
        if (this.textoCriterios) {
            this.textoCriterios = this.textoCriterios.replace(/ {2,}/g, " ");
            this.shortCutComponent = this.$refs.shortCutComponent as ShortcutComponent;
            this.shortCutComponent.title = (this.$t("__.ts.criterios") as string) + " - " + this.tituloModal.toString();
            this.shortCutComponent.show();
        } else {
            await this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.naoFoiPossivelEncontrarCriterios"));
        }
    }
}
